// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1qpEX","errorLogs":"EditorFooter_errorLogs__2uNp3"};